// extracted by mini-css-extract-plugin
export default {"app":"App_app__lqcuq","logo":"App_logo__Yy6P9"};